
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import SEO from "@/components/SEO";
import StructuredData from "@/components/StructuredData";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Données structurées pour la page 404
  const notFoundSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Page non trouvée - Groupe Fabre Environnement",
    "description": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Accueil",
          "item": "https://groupefabre.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Page non trouvée",
          "item": location.pathname
        }
      ]
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <SEO 
        title="Page non trouvée - Groupe Fabre Environnement"
        description="Désolé, la page que vous recherchez n'existe pas ou a été déplacée. Veuillez retourner à l'accueil."
        canonical={location.pathname}
      />
      
      <StructuredData data={notFoundSchema} />
      
      <Navbar />
      <main className="flex-grow flex items-center justify-center py-16" aria-labelledby="not-found-title">
        <div className="text-center max-w-lg px-4">
          <div className="mb-8 bg-fabre-lightgreen w-20 h-20 rounded-full flex items-center justify-center mx-auto">
            <Search className="h-10 w-10 text-fabre-green" aria-hidden="true" />
          </div>
          <h1 id="not-found-title" className="text-2xl font-heading font-semibold mb-4 text-fabre-gray">Page introuvable</h1>
          <p className="text-gray-600 mb-8">
            Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
              <Link to="/">Retourner à l'accueil</Link>
            </Button>
            <Button asChild variant="outline" className="border-fabre-green text-fabre-green hover:bg-fabre-lightgreen">
              <Link to="/contact">Nous contacter</Link>
            </Button>
          </div>
          
          <div className="mt-12">
            <h2 className="text-lg font-semibold mb-4 text-fabre-gray">Pages populaires</h2>
            <ul className="space-y-2">
              <li><Link to="/nos-services" className="text-fabre-green hover:underline">Nos services</Link></li>
              <li><Link to="/sites" className="text-fabre-green hover:underline">Nos sites de recyclage</Link></li>
              <li><Link to="/services/particuliers" className="text-fabre-green hover:underline">Services pour particuliers</Link></li>
              <li><Link to="/services/professionnels" className="text-fabre-green hover:underline">Services pour professionnels</Link></li>
              <li><Link to="/services/collectivites" className="text-fabre-green hover:underline">Services pour collectivités</Link></li>
              <li><Link to="/nos-services/location-bennes" className="text-fabre-green hover:underline">Location de bennes</Link></li>
              <li><Link to="/nos-services/achat-metaux" className="text-fabre-green hover:underline">Achat de métaux</Link></li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
